let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("haJB1")).then(() => parcelRequire('dCJZe'));